module.exports = __webpack_public_path__ + "assets/img/mm_icon.50950ff4.svg";